import styled from 'styled-components';

const KanbanWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: var(--sops-kanban-bg);
  .super-list {
    height: calc(100vh - 216px) !important;
    margin: 0 !important;
    background: var(--sops-kanban-bg);
  }
  .super-list-items {
    height: calc(100% - 80px);
    overflow-y: overlay;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
    // &:hover {
    //   scrollbar-width: 4px;
    //   &::-webkit-scrollbar {
    //     display: block;
    //   }
    // }
  }
  .super-other-lists {
    height: calc(100vh - 216px) !important;
    margin-left: 10px;
  }
  .super-list-items .smooth-dnd-container {
    height: 100% !important;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 4px;
  border-bottom: 1px solid #ececec;
  background-color: white;
  .Polaris-Button--monochrome.Polaris-Button--plain .Polaris-Button__Text {
    text-decoration: none;
  }
  .Polaris-Button {
    height: 3.2rem;
    padding: 0 1.2rem !important;
    color: currentColor;
  }
  .Polaris-Button:hover {
    color: currentColor;
  }
`;

const StyledText = styled.div`
  text-transform: uppercase;
  margin: 0 30px;
`;

const TitleHolder = styled.div`
  width: 280px;
  height: 55px;
  margin: 0 auto 20px;
  background: var(--sops-white-to-grey-bg);
  border-radius: 5px 5px 0px 0px;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 21px;
  font-weight: 600;
  padding: 0 10px;
  position: relative;
  .title {
    width: calc(100% - 20px);
    text-transform: capitalize;
  }
  .mw-25 {
    min-width: 25px !important;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .count {
    background: #f4f5fa;
    width: fit-content;
    height: 20px;
    font-size: 12px;
    text-align: center;
    padding: 0px 4px;
    border-radius: 5px;
  }
  .column-pin {
    top: 0;
    left: 0;
    content: '';
    cursor: pointer;
    position: absolute;
    display: none;

    &.pinned {
      display: block;
    }
  }
  &:hover .column-pin {
    display: block;
  }
`;

export { KanbanWrapper, HeaderContainer, StyledText, TitleHolder };
